export default {
    remains: 'Warehouse Stock',
    download: 'Download',
    length: 'Length',
}
